import { Badge, Button, Card, Col, Dropdown, Form, Modal, Row, Stack } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import Select from "react-select";
import ModalCreateUser from "./ModalCreateUser";
import { useEffect, useState } from "react";
import LoadingStuck from "../../../reuse/LoadingStuck";
import Api, {BaseUrl } from "../../../../api/Api";


const UserCard = ({user_info}) =>{
    const [show, setShow] = useState(false);
    const [changeData, setChangeData]=useState(true);

    const old_username=user_info.username;
    
    const [username, setUsername]=useState(user_info.username);
    const [email, setEmail]=useState(user_info.email);
    const [surname, setSurname]=useState(user_info.surname);
    const [name, setName]=useState(user_info.name);
    const [patronymic, setPatronymic]=useState(user_info.patronymic); 
    const [role, setRole]=useState(user_info.role);
    const [job_title, setJobTitle]=useState(user_info.job_title);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const role_full={
        "Auditor":"Аудитор",
        "Admin":"Администратор",
        "Moderator":"Модератор",
        "User":"Пользователь",
        "Admin-RO":"Администратор наблюдатель"
    }

    const changeUser = async(data, username) => {
        try {
            const response = await Api({
                method:"patch",
                url:`/users/@${username}`,
                headers:{},
                data:data
            })
            alert(`Данные пользователя с username ${username} изменены.`);
            window.location.reload();
        } catch (error) {
            // alert("Ошибка при редактировании пользователя.");
            alert(error);
        }
    }

    const handleChange = async(e) => {
        e.preventDefault();
        const data = {
            "username":username,
            "email":email,
            "surname":surname,
            "patronymic":patronymic,
            "role":role,
            "job_title":job_title
        }
        await changeUser(data,old_username);
    }
    const deleteUser = async(username) => {
        try {
            const response = await Api({
                method:"delete",
                url:`/users/@${username}`,
                headers:{}
            })
            alert("Пользователь удалён из системы!")
            window.location.reload();
        } catch (error) {
            alert(`Ошибка при удалении пользователя. \n ${error}`);
        }
    }

    const handleDelete = async(user_info) =>{
        let warning = window.confirm(`Внимание! Вы уверены, что хотите удалить пользователя ${user_info.username}? Восстановить данные после удаления будет невозможно! `)
        if(warning){
            await deleteUser(old_username);
        }
    }

    return(<>
        <Card className="m-1 card_style" onClick={handleShow}>
            <Card.Body>
                <div>
                    {/* <p>Логин: {user_info.username}</p>
                    {role_full[user_info.role] || ""} */}
                    <div className="text_font">Логин: {user_info.username}</div>
                    <div className="d-flex">
                        <div className="custom_badge_secondary">{role_full[user_info.role] || ""}</div>
                    </div>
                    <div className="text_hidden_overflow text_font">ФИО: {user_info.surname || ""} {user_info.name || ""} {user_info.patronymic || ""}</div>
                </div>
            </Card.Body>
        </Card>

        <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="text_font">Информация о пользователе</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form onSubmit={handleChange}>
                <Row>
                    <Col md={6}>
                        <Form.Control 
                        id="username"
                        className="mb-2"
                        placeholder="Username/логин..."
                        value={username}
                        onChange={(e)=>setUsername(e.target.value)}
                        disabled={changeData}
                        />
                        <Form.Control 
                        className="mb-2"
                        value={surname}
                        onChange={(e)=>setSurname(e.target.value)}
                        placeholder="Фамилия..." 
                        disabled={changeData}
                        />
                        <Form.Control 
                        className="mb-2"
                        value={name}
                        onChange={(e)=>setName(e.target.value)}
                        placeholder="Имя..." 
                        disabled={changeData}
                        />
                        <Form.Control 
                        className="mb-2"
                        value={patronymic}
                        onChange={(e)=>setPatronymic(e.target.value)}
                        placeholder="Отчество..." 
                        disabled={changeData}
                        />
                    </Col>
                    <Col md={6}>
                        <Form.Control 
                        className="mb-2"
                        value={email}
                        onChange={(e)=>setEmail(e.target.value)}
                        type="email" 
                        placeholder="email..."
                        disabled={changeData}
                        />
                        <Form.Select 
                        className="mb-2" 
                        value={role}
                        onChange={(e)=>setRole(e.target.value)}
                        disabled={changeData}>
                        {Object.keys(role_full).map((element)=>(<option key={element} value={element}>{role_full[element]}</option>))}
                        </Form.Select>
                        <Form.Control 
                        value={job_title}
                        onChange={(e)=>setJobTitle(e.target.value)}
                        disabled={changeData}
                        placeholder="Должность..."/>
                    </Col>
                </Row>
                <div>
                    <Form.Check type="switch" checked={!changeData} label="Редактировать данные" id="change_param" onChange={()=>setChangeData(!changeData)}/>
                </div>
                <div className="mt-1" style={{display:"flex", justifyContent:"space-between"}}>
                    <Button variant="light border" disabled={changeData} className="free-btn m-1 border" type="submit">
                        Сохранить изменения
                    </Button> 
                    <Button variant="danger" className="free-btn m-1" onClick={()=>handleDelete(user_info)}>Удалить</Button>
                </div>
            </Form>
        </Modal.Body>
      </Modal>
    </>)
}

const AdminUsersBlockInterface = ({data}) => {

    const [data_users,setDataUsers]=useState(data);
    const filters_users_options=data.map((users)=>{return {value:users.id, label:`${users.surname || ""} ${users.name || ""} ${users.patronymic || ""}`}})
    const [filterValue,setFilterValue]=useState("");

    const handleChange = (selected) => {
        setFilterValue(selected);
        // console.log('Выбрано:', selected);
        if(selected==null){
            setDataUsers(data)
        }else{
            const new_data=data.filter(item => item.id === selected.value);
            setDataUsers(new_data);
        }
    };

    return(
        <>
        <div className="search_filters_admin_block">
            <div>
            <ModalCreateUser/>
            </div>
            <Select 
            className="search_filter_field m-1" 
            options={filters_users_options}
            value={filterValue}
            onChange={handleChange}
            placeholder="поиск по пользователям..." 
            isClearable/>
            {/* <Button className="custom-btn m-1">Поиск</Button> */}
        </div>
        <div>
            {data_users.length==0 ? 
            <p>Нет пользователей</p> 
            : 
            <>
                <Row className="mt-1">
                    {data_users.map((user)=>(
                        <Col key={user.username} md={4} className="mb-1">
                            <UserCard user_info={user}/>
                        </Col>
                    ))}
                </Row>
            </>}
        </div>
        </>
    )
}

const AdminUsersFetch = () => {
    const [loading,setLoading]=useState(false);
    const [error, setError]=useState(false);
    const [block, setBlock]=useState(false);

    const [data,setData]=useState(null);
    const [errorInfo,setErrorInfo]=useState(null);

    const getUsers=async()=>{
        try {
            const response = await Api({
                method:"get",
                url:`/users/`,
                headers:{}
            })
            setBlock(true);
            setData(response.data)
        } catch (error) {
            console.error(error);
            setError(true);
            // setErrorInfo("Ошибка при подгрузке пользователей.");
            setErrorInfo(`Ошибка при подгрузке пользователей. \n ${error}`);
        }
    }

    useEffect(()=>{
        const setup = async() =>{
            setLoading(true)
            await getUsers()
            setLoading(false)
        }
        setup();
    },[])

    if(loading){return(<LoadingStuck/>)}
    if(error){return(<><p className="warning_text sepatate_text">{errorInfo}</p></>)}
    if(block){return(<><AdminUsersBlockInterface data={data}/></>)}
}

const AdminUsersBlock = () =>{
    return(<><AdminUsersFetch/></>)
}

export default AdminUsersBlock;